{
    "Messages_Type_Label": "Nachrichtentyp",
    "Messages_Language_Label": "Sprache",
    "Messages_Language_DefaultOption": "Standard \/ Fallback",
    "Messages_Subject_Label": "Thema",
    "Messages_PlainBody_Label": "Textkörper (reiner Text)",
    "Messages_HtmlBody_Label": "Body (HTML)",
    "Messages_NewLocale_Info": "Beim Speichern wird für diese Sprache ein neuer Nachrichteneintrag erstellt.",
    "Messages_Action_Save": "Speichern",
    "Messages_Action_Revert": "Zurücksetzen",
    "Messages_Action_Delete": "Löschen",
    "Messages_DiscardChanges_Prompt": "Nicht gespeicherte Änderungen verwerfen?",
    "Messages_DiscardChanges_Confirm": "Änderungen verwerfen",
    "Messages_DiscardChanges_Cancel": "Weiter bearbeiten",
    "Messages_Save_Success": "Nachricht gespeichert.",
    "Messages_Save_Error": "Die Nachricht konnte nicht gespeichert werden.",
    "Messages_Delete_Success": "Nachricht gelöscht.",
    "Messages_Delete_Error": "Die Nachricht konnte nicht gelöscht werden.",
    "NAME": "Nachrichtensprache"
}